import axios from 'axios';
import { toast } from 'react-toastify';
import { push } from 'connected-react-router';

// URIs
import serverURI from '../../config/URI';
// Helpers
import errorHandler from '../helpers/errorHandler';

//import { getParties } from './party';

export const LOADING_DISTRIBUTORS = () => ({ type: 'LOADING_DISTRIBUTORS', });
export const LOADING_DISTRIBUTORS_SUCCESS = () => ({ type: 'LOADING_DISTRIBUTORS_SUCCESS', });
export const LOADING_DISTRIBUTORS_ERROR = () => ({ type: 'LOADING_DISTRIBUTORS_ERROR', });

export const ADDING_DISTRIBUTOR = () => ({ type: 'ADDING_DISTRIBUTOR', });
export const ADDING_DISTRIBUTOR_SUCCESS = () => ({ type: 'ADDING_DISTRIBUTOR_SUCCESS', });
export const ADDING_DISTRIBUTOR_ERROR = () => ({ type: 'ADDING_DISTRIBUTOR_ERROR', });

export const UPDATING_DISTRIBUTOR = () => ({ type: 'UPDATING_DISTRIBUTOR', });
export const UPDATING_DISTRIBUTOR_SUCCESS = () => ({ type: 'UPDATING_DISTRIBUTOR_SUCCESS', });
export const UPDATING_DISTRIBUTOR_ERROR = () => ({ type: 'UPDATING_DISTRIBUTOR_ERROR', });

export const DELETING_DISTRIBUTOR = () => ({ type: 'DELETING_DISTRIBUTOR', });
export const DELETING_DISTRIBUTOR_SUCCESS = () => ({ type: 'DELETING_DISTRIBUTOR_SUCCESS', });
export const DELETING_DISTRIBUTOR_ERROR = () => ({ type: 'DELETING_DISTRIBUTOR_ERROR', });

export const FINDING_DISTRIBUTORS = () => ({ type: 'FINDING_DISTRIBUTORS', });
export const FINDING_DISTRIBUTORS_SUCCESS = () => ({ type: 'FINDING_DISTRIBUTORS_SUCCESS', });
export const FINDING_DISTRIBUTORS_ERROR = () => ({ type: 'FINDING_DISTRIBUTORS_ERROR', });



export const LOADING_COMPANIES = () => ({ type: 'LOADING_COMPANIES', });
export const LOADING_COMPANIES_SUCCESS = () => ({ type: 'LOADING_COMPANIES_SUCCESS', });
export const LOADING_COMPANIES_ERROR = () => ({ type: 'LOADING_COMPANIES_ERROR', });

export const ADDING_COMPANY = () => ({ type: 'ADDING_COMPANY', });
export const ADDING_COMPANY_SUCCESS = () => ({ type: 'ADDING_COMPANY_SUCCESS', });
export const ADDING_COMPANY_ERROR = () => ({ type: 'ADDING_COMPANY_ERROR', });

export const UPDATING_COMPANY = () => ({ type: 'UPDATING_COMPANY', });
export const UPDATING_COMPANY_SUCCESS = () => ({ type: 'UPDATING_COMPANY_SUCCESS', });
export const UPDATING_COMPANY_ERROR = () => ({ type: 'UPDATING_COMPANY_ERROR', });

export const DELETING_COMPANY = () => ({ type: 'DELETING_COMPANY', });
export const DELETING_COMPANY_SUCCESS = () => ({ type: 'DELETING_COMPANY_SUCCESS', });
export const DELETING_COMPANY_ERROR = () => ({ type: 'DELETING_COMPANY_ERROR', });

export const LOADING_COMPANY_NAMES = () => ({ type: 'LOADING_COMPANY_NAMES', });
export const LOADING_COMPANY_NAMES_SUCCESS = () => ({ type: 'LOADING_COMPANY_NAMES_SUCCESS', });
export const LOADING_COMPANY_NAMES_ERROR = () => ({ type: 'LOADING_COMPANY_NAMES_ERROR', });

export const FINDING_COMPANIES = () => ({ type: 'FINDING_COMPANIES', });
export const FINDING_COMPANIES_SUCCESS = () => ({ type: 'FINDING_COMPANIES_SUCCESS', });
export const FINDING_COMPANIES_ERROR = () => ({ type: 'FINDING_COMPANIES_ERROR', });

// export const UPLOADING_COMPANY_FILE = () => ({ type: 'UPLOADING_COMPANY_FILE', });
// export const UPLOADING_COMPANY_FILE_SUCCESS = () => ({ type: 'UPLOADING_COMPANY_FILE_SUCCESS', });
// export const UPLOADING_COMPANY_FILE_ERROR = () => ({ type: 'UPLOADING_COMPANY_FILE_ERROR', });



export const LOADING_CARS = () => ({ type: 'LOADING_CARS', });
export const LOADING_CARS_SUCCESS = () => ({ type: 'LOADING_CARS_SUCCESS', });
export const LOADING_CARS_ERROR = () => ({ type: 'LOADING_CARS_ERROR', });

export const ADDING_CAR = () => ({ type: 'ADDING_CAR', });
export const ADDING_CAR_SUCCESS = () => ({ type: 'ADDING_CAR_SUCCESS', });
export const ADDING_CAR_ERROR = () => ({ type: 'ADDING_CAR_ERROR', });

export const UPDATING_CAR = () => ({ type: 'UPDATING_CAR', });
export const UPDATING_CAR_SUCCESS = () => ({ type: 'UPDATING_CAR_SUCCESS', });
export const UPDATING_CAR_ERROR = () => ({ type: 'UPDATING_CAR_ERROR', });

export const DELETING_CAR = () => ({ type: 'DELETING_CAR', });
export const DELETING_CAR_SUCCESS = () => ({ type: 'DELETING_CAR_SUCCESS', });
export const DELETING_CAR_ERROR = () => ({ type: 'DELETING_CAR_ERROR', });

export const LOADING_CAR_NUMBERS = () => ({ type: 'LOADING_CAR_NUMBERS', });
export const LOADING_CAR_NUMBERS_SUCCESS = () => ({ type: 'LOADING_CAR_NUMBERS_SUCCESS', });
export const LOADING_CAR_NUMBERS_ERROR = () => ({ type: 'LOADING_CAR_NUMBERS_ERROR', });

export const FINDING_CARS = () => ({ type: 'FINDING_CARS', });
export const FINDING_CARS_SUCCESS = () => ({ type: 'FINDING_CARS_SUCCESS', });
export const FINDING_CARS_ERROR = () => ({ type: 'FINDING_CARS_ERROR', });



export const LOADING_AGENCIES = () => ({ type: 'LOADING_AGENCIES', });
export const LOADING_AGENCIES_SUCCESS = () => ({ type: 'LOADING_AGENCIES_SUCCESS', });
export const LOADING_AGENCIES_ERROR = () => ({ type: 'LOADING_AGENCIES_ERROR', });

export const ADDING_AGENCY = () => ({ type: 'ADDING_AGENCY', });
export const ADDING_AGENCY_SUCCESS = () => ({ type: 'ADDING_AGENCY_SUCCESS', });
export const ADDING_AGENCY_ERROR = () => ({ type: 'ADDING_AGENCY_ERROR', });

export const UPDATING_AGENCY = () => ({ type: 'UPDATING_AGENCY', });
export const UPDATING_AGENCY_SUCCESS = () => ({ type: 'UPDATING_AGENCY_SUCCESS', });
export const UPDATING_AGENCY_ERROR = () => ({ type: 'UPDATING_AGENCY_ERROR', });

export const DELETING_AGENCY = () => ({ type: 'DELETING_AGENCY', });
export const DELETING_AGENCY_SUCCESS = () => ({ type: 'DELETING_AGENCY_SUCCESS', });
export const DELETING_AGENCY_ERROR = () => ({ type: 'DELETING_AGENCY_ERROR', });

export const FINDING_AGENCIES = () => ({ type: 'FINDING_AGENCIES', });
export const FINDING_AGENCIES_SUCCESS = () => ({ type: 'FINDING_AGENCIES_SUCCESS', });
export const FINDING_AGENCIES_ERROR = () => ({ type: 'FINDING_AGENCIES_ERROR', });



export const LOADING_CLIENTS = () => ({ type: 'LOADING_CLIENTS', });
export const LOADING_CLIENTS_SUCCESS = () => ({ type: 'LOADING_CLIENTS_SUCCESS', });
export const LOADING_CLIENTS_ERROR = () => ({ type: 'LOADING_CLIENTS_ERROR', });

export const ADDING_CLIENT = () => ({ type: 'ADDING_CLIENT', });
export const ADDING_CLIENT_SUCCESS = () => ({ type: 'ADDING_CLIENT_SUCCESS', });
export const ADDING_CLIENT_ERROR = () => ({ type: 'ADDING_CLIENT_ERROR', });

export const UPDATING_CLIENT = () => ({ type: 'UPDATING_CLIENT', });
export const UPDATING_CLIENT_SUCCESS = () => ({ type: 'UPDATING_CLIENT_SUCCESS', });
export const UPDATING_CLIENT_ERROR = () => ({ type: 'UPDATING_CLIENT_ERROR', });

export const DELETING_CLIENT = () => ({ type: 'DELETING_CLIENT', });
export const DELETING_CLIENT_SUCCESS = () => ({ type: 'DELETING_CLIENT_SUCCESS', });
export const DELETING_CLIENT_ERROR = () => ({ type: 'DELETING_CLIENT_ERROR', });

export const FINDING_CLIENTS = () => ({ type: 'FINDING_CLIENTS', });
export const FINDING_CLIENTS_SUCCESS = () => ({ type: 'FINDING_CLIENTS_SUCCESS', });
export const FINDING_CLIENTS_ERROR = () => ({ type: 'FINDING_CLIENTS_ERROR', });



export const getDistributors = (dispatch) => {
  dispatch({ type: LOADING_DISTRIBUTORS });

  axios
    .get(`${serverURI}/api/company/distributor/all`)
    .then((res) => {
      //console.log(res);
      dispatch({
        type: LOADING_DISTRIBUTORS_SUCCESS,
        payload: res.data.distributors
      });
    })
    .catch((err) => {
      dispatch({ type: LOADING_DISTRIBUTORS_ERROR, payload: err });
      errorHandler(err);
    });
};


export const addDistributor = (distributor, dispatch) => {
  dispatch({ type: ADDING_DISTRIBUTOR });

  axios
    .post(`${serverURI}/api/company/distributor/add`, distributor)
    .then((res) => {
      //console.log(res);
      dispatch({ type: ADDING_DISTRIBUTOR_SUCCESS, 
        payload: res.data.distributor, 
        });
    })
    .catch((err) => {
      dispatch({ type: ADDING_DISTRIBUTOR_ERROR, payload: err });
      errorHandler(err);
    });
};

export const updateDistributor = (id, distributor, dispatch) => {
  dispatch({ type: UPDATING_DISTRIBUTOR });

  axios
    .put(`${serverURI}/api/company/distributor/update/${id}`, distributor)
    .then((res) => {
      //console.log(res);
      dispatch({ type: UPDATING_DISTRIBUTOR_SUCCESS, 
        payload: res.data.distributor, 
        });
    })
    .catch((err) => {
      dispatch({ type: UPDATING_DISTRIBUTOR_ERROR, payload: err });
      errorHandler(err);
    });
};

export const deleteDistributor = (deletes, dispatch) => {
  dispatch({ type: DELETING_DISTRIBUTOR });

  const deleteData = {
    deletes: deletes,
  };

  return axios
    .delete(`${serverURI}/api/company/distributor/delete`, {data: deleteData})
    .then((res) => {
      //console.log(res);
      dispatch({ type: DELETING_DISTRIBUTOR_SUCCESS, 
        payload: res.data.deletedDistributors, 
        });
    })
    .catch((err) => {
      dispatch({ type: DELETING_DISTRIBUTOR_ERROR, payload: err });
      errorHandler(err);
    });
};


export const findDistributors = (find, dispatch) => {
  dispatch({ type: FINDING_DISTRIBUTORS });

  axios
    .post(`${serverURI}/api/company/distributor/find`, find)
    .then((res) => {
      //console.log(res);
      dispatch({ type: FINDING_DISTRIBUTORS_SUCCESS, 
        payload: {
          find_total: res.data.total,
          find_distributors: res.data.distributors
        }
        });
    })
    .catch((err) => {
      dispatch({ type: FINDING_DISTRIBUTORS_ERROR, payload: err });
      errorHandler(err);
    });
};

export const removeDistributors = (dispatch) => {
  dispatch({ type: FINDING_DISTRIBUTORS_SUCCESS, 
    payload: {
      find_total: 0,
      find_distributors: []
    }
  });

};









export const getCompanies = (dispatch) => {
  dispatch({ type: LOADING_COMPANIES });

  //console.log('getCompanies -> ');

  axios
    .get(`${serverURI}/api/company/taxi/all`)
    .then((res) => {
      //console.log(res);
      dispatch({
        type: LOADING_COMPANIES_SUCCESS,
        payload: res.data.companies
      });
    })
    .catch((err) => {
      dispatch({ type: LOADING_COMPANIES_ERROR, payload: err });
      errorHandler(err);
    });
};

export const addCompany = (company, dispatch) => {
  dispatch({ type: ADDING_COMPANY });

  axios
    .post(`${serverURI}/api/company/taxi/add`, company)
    .then((res) => {
      //console.log(res);
      dispatch({ type: ADDING_COMPANY_SUCCESS, 
        payload: res.data.company, 
        });
    })
    .catch((err) => {
      dispatch({ type: ADDING_COMPANY_ERROR, payload: err });
      errorHandler(err);
    });
};

export const updateCompany = (id, company, dispatch) => {
  dispatch({ type: UPDATING_COMPANY });

  axios
    .put(`${serverURI}/api/company/taxi/update/${id}`, company)
    .then((res) => {
      //console.log(res);
      dispatch({ type: UPDATING_COMPANY_SUCCESS, 
        payload: res.data.company, 
        });
    })
    .catch((err) => {
      dispatch({ type: UPDATING_COMPANY_ERROR, payload: err });
      errorHandler(err);
    });
};

export const deleteCompany = (deletes, dispatch) => {
  dispatch({ type: DELETING_COMPANY });

  const deleteData = {
    deletes: deletes,
  };

  return axios
    .delete(`${serverURI}/api/company/taxi/delete`, {data: deleteData})
    .then((res) => {
      //console.log(res);
      dispatch({ type: DELETING_COMPANY_SUCCESS, 
        payload: res.data.deletedCompanies, 
        });
    })
    .catch((err) => {
      dispatch({ type: DELETING_COMPANY_ERROR, payload: err });
      errorHandler(err);
    });
};


export const getCompanyNames = (dispatch) => {
  dispatch({ type: LOADING_COMPANY_NAMES });

  //console.log('getCompanies -> ');

  axios
    .get(`${serverURI}/api/company/taxi/name/all`)
    .then((res) => {
      //console.log(res);
      dispatch({
        type: LOADING_COMPANY_NAMES_SUCCESS,
        payload: res.data.company_names
      });
    })
    .catch((err) => {
      dispatch({ type: LOADING_COMPANY_NAMES_ERROR, payload: err });
      errorHandler(err);
    });
};


export const findCompanies = (find, dispatch) => {
  dispatch({ type: FINDING_COMPANIES });

  axios
    .post(`${serverURI}/api/company/taxi/find`, find)
    .then((res) => {
      //console.log(res);
      dispatch({ type: FINDING_COMPANIES_SUCCESS, 
        payload: {
          find_total: res.data.total,
          find_companies: res.data.companies
        }
        });
    })
    .catch((err) => {
      dispatch({ type: FINDING_COMPANIES_ERROR, payload: err });
      errorHandler(err);
    });
};

export const removeCompanies = (dispatch) => {
  dispatch({ type: FINDING_DISTRIBUTORS_SUCCESS, 
    payload: {
      find_total: 0,
      find_distributors: []
    }
  });

};


// export const uploadCompanyFile = (file, dispatch) => {
//   dispatch({ type: UPLOADING_COMPANY_FILE });

//   const fileData = new FormData();
  
//   fileData.append('xlsFile', file);

//   axios
//     .post(`${serverURI}/api/company/taxi/upload`, fileData)
//     .then((res) => {
//       dispatch({ type: UPLOADING_COMPANY_FILE_SUCCESS, 
//         payload: res.data.companies, 
//         });
//     })
//     .catch((err) => {
//       dispatch({ type: UPLOADING_COMPANY_FILE_ERROR, payload: err });
//       errorHandler(err);
//     });
// };







export const getCars = (dispatch) => {
  dispatch({ type: LOADING_CARS });

  axios
    .get(`${serverURI}/api/company/car/all`)
    .then((res) => {
      //console.log(res);
      dispatch({
        type: LOADING_CARS_SUCCESS,
        payload: res.data.cars
      });
    })
    .catch((err) => {
      dispatch({ type: LOADING_CARS_ERROR, payload: err });
      errorHandler(err);
    });
};


export const addCar = (car, dispatch) => {
  dispatch({ type: ADDING_CAR });

  axios
    .post(`${serverURI}/api/company/car/add`, car)
    .then((res) => {
      //console.log(res);
      dispatch({ type: ADDING_CAR_SUCCESS, 
        payload: res.data.car, 
        });
    })
    .catch((err) => {
      dispatch({ type: ADDING_CAR_ERROR, payload: err });
      errorHandler(err);
    });
};

export const updateCar = (id, car, dispatch) => {
  dispatch({ type: UPDATING_CAR });

  axios
    .put(`${serverURI}/api/company/car/update/${id}`, car)
    .then((res) => {
      //console.log(res);
      dispatch({ type: UPDATING_CAR_SUCCESS, 
        payload: res.data.car, 
        });
    })
    .catch((err) => {
      dispatch({ type: UPDATING_CAR_ERROR, payload: err });
      errorHandler(err);
    });
};

export const deleteCar = (deletes, dispatch) => {
  dispatch({ type: DELETING_CAR });

  const deleteData = {
    deletes: deletes,
  };

  return axios
    .delete(`${serverURI}/api/company/car/delete`, {data: deleteData})
    .then((res) => {
      //console.log(res);
      dispatch({ type: DELETING_CAR_SUCCESS, 
        payload: res.data.deletedCars, 
        });
    })
    .catch((err) => {
      dispatch({ type: DELETING_CAR_ERROR, payload: err });
      errorHandler(err);
    });
};


export const getCarNumbers = (dispatch) => {
  dispatch({ type: LOADING_CAR_NUMBERS });

  //console.log('getCompanies -> ');

  axios
    .get(`${serverURI}/api/company/car/number/all`)
    .then((res) => {
      //console.log(res);
      dispatch({
        type: LOADING_CAR_NUMBERS_SUCCESS,
        payload: res.data.car_numbers
      });
    })
    .catch((err) => {
      dispatch({ type: LOADING_CAR_NUMBERS_ERROR, payload: err });
      errorHandler(err);
    });
};

export const findCars = (find, dispatch) => {
  dispatch({ type: FINDING_CARS });

  axios
    .post(`${serverURI}/api/company/car/find`, find)
    .then((res) => {
      //console.log(res);
      dispatch({ type: FINDING_CARS_SUCCESS, 
        payload: {
          find_total: res.data.total,
          find_cars: res.data.cars
        }
      });
    })
    .catch((err) => {
      dispatch({ type: FINDING_CARS_ERROR, payload: err });
      errorHandler(err);
    });
};

export const removeCars = (dispatch) => {
  dispatch({ type: FINDING_CARS_SUCCESS, 
    payload: {
      find_total: 0,
      find_cars: []
    }
  });

};








export const getAgencies = (dispatch) => {
  dispatch({ type: LOADING_AGENCIES });

  axios
    .get(`${serverURI}/api/company/agency/all`)
    .then((res) => {
      //console.log(res);
      dispatch({
        type: LOADING_AGENCIES_SUCCESS,
        payload: res.data.agencies
      });
    })
    .catch((err) => {
      dispatch({ type: LOADING_AGENCIES_ERROR, payload: err });
      errorHandler(err);
    });
};

export const getUserAgencies = (userid, dispatch) => {
  dispatch({ type: LOADING_AGENCIES });

  axios
    .get(`${serverURI}/api/company/agency/user/${userid}`)
    .then((res) => {
      //console.log(res);
      dispatch({
        type: LOADING_AGENCIES_SUCCESS,
        payload: res.data.agencies
      });
    })
    .catch((err) => {
      dispatch({ type: LOADING_AGENCIES_ERROR, payload: err });
      errorHandler(err);
    });
};


export const addAgency = (agency, dispatch) => {
  dispatch({ type: ADDING_AGENCY });

  axios
    .post(`${serverURI}/api/company/agency/add`, agency)
    .then((res) => {
      //console.log(res);
      dispatch({ type: ADDING_AGENCY_SUCCESS, 
        payload: res.data.agency, 
        });
    })
    .catch((err) => {
      dispatch({ type: ADDING_AGENCY_ERROR, payload: err });
      errorHandler(err);
    });
};

export const updateAgency = (id, agency, dispatch) => {
  dispatch({ type: UPDATING_AGENCY });

  axios
    .put(`${serverURI}/api/company/agency/update/${id}`, agency)
    .then((res) => {
      //console.log(res);
      dispatch({ type: UPDATING_AGENCY_SUCCESS, 
        payload: res.data.agency, 
        });
    })
    .catch((err) => {
      dispatch({ type: UPDATING_AGENCY_ERROR, payload: err });
      errorHandler(err);
    });
};

export const deleteAgency = (deletes, dispatch) => {
  dispatch({ type: DELETING_AGENCY });

  const deleteData = {
    deletes: deletes,
  };

  return axios
    .delete(`${serverURI}/api/company/agency/delete`, {data: deleteData})
    .then((res) => {
      //console.log(res);
      dispatch({ type: DELETING_AGENCY_SUCCESS, 
        payload: res.data.deletedAgencies, 
        });
    })
    .catch((err) => {
      dispatch({ type: DELETING_AGENCY_ERROR, payload: err });
      errorHandler(err);
    });
};

export const findAgencies = (find, dispatch) => {
  dispatch({ type: FINDING_AGENCIES });

  axios
    .post(`${serverURI}/api/company/agency/find`, find)
    .then((res) => {
      //console.log(res);
      dispatch({ type: FINDING_AGENCIES_SUCCESS, 
        payload: {
          find_total: res.data.total,
          find_agencies: res.data.agencies
        }
      });
    })
    .catch((err) => {
      dispatch({ type: FINDING_AGENCIES_ERROR, payload: err });
      errorHandler(err);
    });
};

export const removeAgencies = (dispatch) => {
  dispatch({ type: FINDING_AGENCIES_SUCCESS, 
    payload: {
      find_total: 0,
      find_agencies: []
    }
  });

};







export const getClients = (dispatch) => {
  dispatch({ type: LOADING_CLIENTS });

  axios
    .get(`${serverURI}/api/company/client/all`)
    .then((res) => {
      //console.log(res);
      dispatch({
        type: LOADING_CLIENTS_SUCCESS,
        payload: res.data.clients
      });
    })
    .catch((err) => {
      dispatch({ type: LOADING_CLIENTS_ERROR, payload: err });
      errorHandler(err);
    });
};

export const getUserClients = (userid, dispatch) => {
  dispatch({ type: LOADING_CLIENTS });

  axios
    .get(`${serverURI}/api/company/client/user/${userid}`)
    .then((res) => {
      //console.log(res);
      dispatch({
        type: LOADING_CLIENTS_SUCCESS,
        payload: res.data.clients
      });
    })
    .catch((err) => {
      dispatch({ type: LOADING_CLIENTS_ERROR, payload: err });
      errorHandler(err);
    });
};


export const addClient = (client, dispatch) => {
  dispatch({ type: ADDING_CLIENT });

  axios
    .post(`${serverURI}/api/company/client/add`, client)
    .then((res) => {
      //console.log(res);
      dispatch({ type: ADDING_CLIENT_SUCCESS, 
        payload: res.data.client, 
        });
    })
    .catch((err) => {
      dispatch({ type: ADDING_CLIENT_ERROR, payload: err });
      errorHandler(err);
    });
};

export const updateClient = (id, client, dispatch) => {
  dispatch({ type: UPDATING_CLIENT });

  axios
    .put(`${serverURI}/api/company/client/update/${id}`, client)
    .then((res) => {
      //console.log(res);
      dispatch({ type: UPDATING_CLIENT_SUCCESS, 
        payload: res.data.client, 
        });
    })
    .catch((err) => {
      dispatch({ type: UPDATING_CLIENT_ERROR, payload: err });
      errorHandler(err);
    });
};

export const deleteClient = (deletes, dispatch) => {
  dispatch({ type: DELETING_CLIENT });

  const deleteData = {
    deletes: deletes,
  };

  return axios
    .delete(`${serverURI}/api/company/client/delete`, {data: deleteData})
    .then((res) => {
      //console.log(res);
      dispatch({ type: DELETING_CLIENT_SUCCESS, 
        payload: res.data.deletedClients, 
        });
    })
    .catch((err) => {
      dispatch({ type: DELETING_CLIENT_ERROR, payload: err });
      errorHandler(err);
    });
};


export const findClients = (find, dispatch) => {
  dispatch({ type: FINDING_CLIENTS });

  axios
    .post(`${serverURI}/api/company/client/find`, find)
    .then((res) => {
      //console.log(res);
      dispatch({ type: FINDING_CLIENTS_SUCCESS, 
        payload: {
          find_total: res.data.total,
          find_clients: res.data.clients
        }
      });
    })
    .catch((err) => {
      dispatch({ type: FINDING_CLIENTS_ERROR, payload: err });
      errorHandler(err);
    });
};

export const removeClients = (dispatch) => {
  dispatch({ type: FINDING_CLIENTS_SUCCESS, 
    payload: {
      find_total: 0,
      find_clients: []
    }
  });

};